import type { SettlementBatchSummary } from "../types";
import { Button } from "./ui/Button";

export function PayrollSmsButton({ batch, onClick }: { batch: SettlementBatchSummary; onClick: () => void }) {
  const sent = batch.messageCount > 0 && batch.messageSentCount >= batch.messageCount;
  const attention = !sent && ((batch.messageAttentionCount ?? 0) > 0 || (batch.status === "prepared" && batch.messageCount === 0));
  const title = sent ? `${batch.messageSentCount.toLocaleString()}명에게 발송을 마쳤습니다.`
    : attention ? "전송 문자 확인 필요: 수신번호·문자 내용·발송 상태를 확인해 주세요." : "전송 문자";
  return <Button size="icon" className={`payroll-sms-button${sent ? " sent" : ""}`} data-testid="open-settlement-sms"
    aria-label={sent ? "전송 문자 발송 완료" : attention ? "전송 문자 확인 필요" : "전송 문자"} title={title} onClick={onClick}>
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="3" y="5" width="18" height="14" rx="2" /><path d="m4 7 8 6 8-6" />
    </svg>
    {sent && <span className="payroll-sms-sent-check" data-testid="settlement-sms-sent-check" aria-hidden="true">✓</span>}
    {attention && <span className="payroll-sms-attention" data-testid="settlement-sms-attention" aria-hidden="true" />}
  </Button>;
}
